/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_points_legend_tw = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teamwork (both in Q3)`)
};

const es_f1_points_legend_tw = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabajo en equipo (ambos en Q3)`)
};

const de_f1_points_legend_tw = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teamwork (beide in Q3)`)
};

const nl_f1_points_legend_tw = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teamwork (beiden in Q3)`)
};

const fr_f1_points_legend_tw = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Travail d’équipe (tous deux en Q3)`)
};

const it_f1_points_legend_tw = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lavoro di squadra (entrambi in Q3)`)
};

const pt_br2_f1_points_legend_tw = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabalho em equipe (ambos no Q3)`)
};

const pt_f1_points_legend_tw = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabalho em equipa (ambos no Q3)`)
};

const ja_f1_points_legend_tw = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チームワーク（両者Q3）`)
};

const zh_f1_points_legend_tw = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`团队合作（双车Q3）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_points_legend_tw = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_points_legend_tw(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_points_legend_tw", locale)
	if (locale === "en") return en_f1_points_legend_tw(inputs)
	if (locale === "es") return es_f1_points_legend_tw(inputs)
	if (locale === "de") return de_f1_points_legend_tw(inputs)
	if (locale === "nl") return nl_f1_points_legend_tw(inputs)
	if (locale === "fr") return fr_f1_points_legend_tw(inputs)
	if (locale === "it") return it_f1_points_legend_tw(inputs)
	if (locale === "pt-BR") return pt_br2_f1_points_legend_tw(inputs)
	if (locale === "pt") return pt_f1_points_legend_tw(inputs)
	if (locale === "ja") return ja_f1_points_legend_tw(inputs)
	return zh_f1_points_legend_tw(inputs)
};